:host {
   display: block;
}

.dropdown-item {
   white-space: normal;
   padding: 10px 20px;
   background: none;
   color: #000;
   border-top: 1px solid #d5d5d5;
}
